import evanPic from "@/public/images/artists/evan.png";
import { Artist } from "@/types/types";

export const evan = {
  id: "223",
  name: "Evan",
  image: evanPic,
  description: `Evan's delivery is sharp, direct, and packed with intensity. His voice carries a unique texture, blending smoothness with a subtle rasp and slight slur, creating a sound that’s both authentic and compelling.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fevan-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 51,
        high: 65,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
